import React, { CSSProperties } from "react";
import { Box, Icons } from "fds";
import classNames from "classnames";
interface RevisionTagProps {
  auth: "MASTER" | "WORKGROUP" | "IND" | "NONE";
  classes?: string;
  style?: CSSProperties;
}
const AuthDotIcon: React.FC<RevisionTagProps> = ({ auth, classes, style }) => {
  const authColor = {
    MASTER: "#05C072",
    WORKGROUP: "#3182F6",
    IND: "#FAA131",
    NONE: "#7287A2",
  };
  return (
    <Box
      width={16}
      height={16}
      alignItems={"center"}
      justifyContent="center"
      style={style}
    >
      <Icons
        variant="fill"
        label="dot"
        stroke={authColor[auth]}
        classes={classNames("authDot", classes)}
      />
    </Box>
  );
};
export default AuthDotIcon;
